<form>
  <div class="lv-modal-dialog">
    <div mat-dialog-title class="lv-dialog-header">
      <div class="lv-dialog-header-title">
        {{ 'MODAL_DIALOG.ANTRAG_SPEICHERN.TITEL' | translate }}
      </div>
      <div class="lv-dialog-icon-close">
        <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
      </div>
    </div>
    <div mat-dialog-content class="lv-dialog-content">
      <lv-uiartefakt-container [uiArtefakte]="data.artefakte"></lv-uiartefakt-container>
    </div>
    <div *ngIf="(showSpinner$ | async) === false">
      <div class="lv-dialog-buttons" mat-dialog-actions align="end">
        <button mat-raised-button color="accent" (click)="closeDialog()">
          {{ 'MODAL_DIALOG.BUTTON_ABBRECHEN' | translate }}
        </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="valuesMissing()">
          Speichern
        </button>
      </div>
    </div>
  </div>
</form>
